(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-add-card')) {
    customElements.define('quick-add-card', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.error = this.querySelector('.quick-add__error');

        if (!this.form || !this.button) return;
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.addEventListener('click', (event) => event.stopPropagation());
      }

      async onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.button.disabled || this.button.getAttribute('aria-busy') === 'true') return;

        this.button.setAttribute('aria-busy', 'true');
        this.error.hidden = true;

        try {
          const response = await fetch(window.theme.routes.cartAdd, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form)
          });
          const item = await response.json();
          if (!response.ok) throw new Error(item.description || item.message || 'Unable to add this item.');

          const cartResponse = await fetch(window.theme.routes.cart + '.js');
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach((count) => {
            count.textContent = cart.item_count;
            count.classList.remove('hide');
          });

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
          document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } }));

          if (!window.theme.settings || window.theme.settings.cartType !== 'drawer') {
            window.location.href = window.theme.routes.cart;
          }
        } catch (error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
